import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';

import {AuthenticationService} from '../_services';
import {JwtHelperService} from '@auth0/angular-jwt';
import {Role} from '../_models/users/Role';
import {ToastrService} from 'ngx-toastr';
import {JwtToken} from '../_services/users/JwtToken';

@Injectable({providedIn: 'root'})
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private toastr: ToastrService,
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const user = this.authenticationService.userValue;
    if (user) {
      const roles: string[] = (user as any)?.roles ?? [];
      if (route.data.roles && roles.includes(Role.User)) {
        this.router.navigate(['client']);
        return true;
      }
      if (!this.authenticationService.userValue?.token) {
        this.router.navigate(['prospect']);
        this.toastr.error('erreur lors de la création du compte , veuillez contacter l\'administrateur du compte dans votre société,  ou envoyez un mail à  contact@nextms.fr pour des informations complémentaires. ', '', { timeOut: 7000 })
        // return true;
      }
      // logged in so return true
      return true;
    } else {
      // not logged in so redirect to login page with the return url
      this.router.navigate(['prospect'], { queryParams: { returnUrl: state.url } });
      return false;
    }
  }
}
